/* eslint-disable */
export default {
  unknown: 'Unbekannt',
  anonymous: 'Anonym',
  activeCalls: 'Alle Anrufe',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
